/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface InsuranceCardExtractionRequest {
  /**
   * IDs of the uploaded insurance card image attachments (e.g. front and back)
   * @minItems 1
   */
  attachment_ids: string[];
}
